import { render, staticRenderFns } from "./UploadStatus.vue?vue&type=template&id=98cd7efa&scoped=true&"
import script from "./UploadStatus.vue?vue&type=script&lang=js&"
export * from "./UploadStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98cd7efa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('98cd7efa')) {
      api.createRecord('98cd7efa', component.options)
    } else {
      api.reload('98cd7efa', component.options)
    }
    module.hot.accept("./UploadStatus.vue?vue&type=template&id=98cd7efa&scoped=true&", function () {
      api.rerender('98cd7efa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/SeaExport/IntelligentBooking/components/UploadStatus.vue"
export default component.exports